import { AccommodationTagListFiltersCriteria } from './../objects/accommodationTagList';
import { AccommodationTag } from "../objects/accommodationTag";
import { AccommodationTagListConfiguration, AccommodationTagListCriteria } from "../objects/accommodationTagList";
import { Column } from "../objects/column";

export const ACCOMMODATION_TAG_MODULE = 'ACCOMMODATION_TAG_MODULE';

export const EMPTY_ACCOMMODATION_TAG: AccommodationTag = {
    name: '',
    icon: null,
    localization: [],
    name_locales: {},
    display_on_quotation: true,
    display_on_minisite: true
};

export const EMPTY_ACCOMMODATION_TAG_LIST_FILTERS: AccommodationTagListFiltersCriteria = {
    name: '',
    display_on_quotation: 'ALL',
    display_on_minisite: 'ALL',
    creator: '',
    last_author: '',
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 0,
    period: 'CREATION'
};

export const EMPTY_ACCOMMODATION_TAG_LIST_CRITERIA: AccommodationTagListCriteria = {
    search: '',
    page: 0,
    limit: 50,
    order: "desc",
    order_by: "",
    filters: EMPTY_ACCOMMODATION_TAG_LIST_FILTERS
};


export const DEFAULT_COLUMN: Column[] = [
    {
        label: 'name',
        field_name: 'NAME',
        checked: true,
        order_by: 'name',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'display_on_minisite',
        field_name: 'DISPLAY_ON_MINISITE',
        checked: false,
        order_by: 'display_on_minisite',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'display_on_quotation',
        field_name: 'DISPLAY_ON_QUOTATION',
        checked: false,
        order_by: 'display_on_quotation',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: false,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: false,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false
    }
];


export const EMPTY_ACCOMMODATION_TAG_LIST_CONFIGURATION: AccommodationTagListConfiguration = {
    columns: DEFAULT_COLUMN,
    preferences: []
};

